import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import SuccessAlert from './../child/Alert/SuccessAlert';
import DengerAlert from './../child/Alert/DengerAlert';




const SignInLayer = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [successMessage, setSuccessMessage] = useState(""); // Manage Success Message
  const [errorMessage, setErrorMessage] = useState(""); // Manage Success Message
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const savedEmail = localStorage.getItem("rememberedEmail");
    const savedPassword = localStorage.getItem("rememberedPassword");
    if (savedEmail && savedPassword) {
      setEmail(savedEmail);
      setPassword(savedPassword);
      setRememberMe(true);
    }
    const token = localStorage.getItem("authToken");
    if (token) {
      navigate("/dashboard"); // Redirect if already logged in
    }
    document.body.classList.add("signin-page");
    return () => {
      document.body.classList.remove("signin-page"); // Cleanup when leaving the page
    };
  }, [navigate]);


  const validateInputs = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (!password) {
      newErrors.password = "Password is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleLogin = async (e) => {
    e.preventDefault(); // Prevent form reload

    if (!validateInputs()) return;

    setLoading(true);
    const API_ENDPOINT = `${process.env.REACT_APP_BASE_URL}/admin/signIn`;
    
    
    try {
      const response = await fetch(API_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        throw new Error("SignIn failed! Check credentials.");
      }

      const data = await response.json();
    
      localStorage.setItem("authToken", data.token);
      localStorage.setItem("name", data.user.name);
      localStorage.setItem("admin_id", data.user._id);
      localStorage.setItem("profile_picture", data.user.profilePicture);
      localStorage.setItem("user_role", data.user.role);
      localStorage.setItem("permissions", JSON.stringify(data.user.permissions));
      if (rememberMe) {
        localStorage.setItem("rememberedEmail", email);
        localStorage.setItem("rememberedPassword", password);
      } else {
        localStorage.removeItem("rememberedEmail");
        localStorage.removeItem("rememberedPassword");
      }
      
      setSuccessMessage("SignIn successful! Redirecting...");
      setTimeout(() => {
        setSuccessMessage("");
        navigate("/dashboard");
      }, 3000);
      //navigate("/dashboard"); // Redirect to dashboard after login
    } catch (error) {
      setErrorMessage(error.message);
      setTimeout(() => {
        setErrorMessage("");
      }, 3000);
    } finally {
      setLoading(false);
    }
  };

  return (

    <section className="auth bg-base d-flex flex-wrap">
       {successMessage && <SuccessAlert message={successMessage} onClose={() => setSuccessMessage("")} />}
       {errorMessage && <DengerAlert message={errorMessage} onClose={() => setErrorMessage("")} />}
      <div className="auth-left d-lg-block d-none">
        <div className="d-flex align-items-center flex-column h-100 justify-content-center">
          <img src={`${process.env.REACT_APP_PUBLIC_UR}/assets/images/auth/auth-img2.png`}  alt="Auth" />
        </div>
      </div>
      <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
        <div className="max-w-464-px mx-auto w-100">
          <div>
            {/* <Link to="/" className="mb-40 max-w-290-px"> */}
               <img src={`${process.env.REACT_APP_PUBLIC_UR}/assets/images/logo.png`} alt="Logo" /> 
            {/* </Link> */}
            <h4 className="mb-12">Sign In to your Account</h4>
            <p className="mb-32 text-secondary-light text-lg">
              Welcome back! Please enter your details.
            </p>
          </div>

          <form onSubmit={handleLogin}>
            {/* Email Field */}
            <div className="icon-field mb-16">
              <span className="icon top-50 translate-middle-y">
                <Icon icon="mage:email" />
              </span>
              <input
                type="email"
                className="form-control h-56-px bg-neutral-50 radius-12"
                placeholder="Enter Email"
                autoComplete="email"
                maxLength="64"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setErrors((prev) => ({ ...prev, email: "" }));
                }}
              />
              
            </div>
            {errors.email && <p className="text-danger mt-1">{errors.email}</p>}

            {/* Password Field */}
            <div className="position-relative mb-20">
              <div className="icon-field">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="solar:lock-password-outline" />
                </span>
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control h-56-px bg-neutral-50 radius-12"
                  id="your-password"
                  placeholder="Enter Password"
                  autoComplete="current-password"
                  maxLength="20"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setErrors((prev) => ({ ...prev, password: "" }));
                  }}
                />
                <span
                  className="toggle-password  cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <Icon icon={showPassword ? "solar:eye-bold" : "solar:eye-closed-bold"} />
                </span>
              </div>
             
            </div>
            {errors.password && <p className="text-danger mt-1">{errors.password}</p>}

            {/* Remember Me */}
            <div className="d-flex justify-content-between gap-2">
              <div className="form-check style-check d-flex align-items-center">
                <input
                  className="form-check-input border border-neutral-300"
                  type="checkbox"
                  id="remember"
                  checked={rememberMe}
                onChange={() => setRememberMe(!rememberMe)}
                />
                <label className="form-check-label" htmlFor="remember">
                  Remember me
                </label>
              </div>
               <Link to="/forgotpassword" className='text-primary-600 fw-medium'>
                  Forgot Password?
                </Link>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
              disabled={loading}
            >
              {loading ? "Signing In..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default SignInLayer;
